import React, { useState, useEffect } from 'react';
import { useAuth } from '../components/AuthContext';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import Navbar from './Navbar';
import './EditProfile.css';

const EditProfile = () => {
  const { currentUser } = useAuth();
  const [userData, setUserData] = useState({
    name: '',
    apellido: '',
    telefono: '',
    email: '',
    recibirNotificaciones: false, // Nuevo campo para recibir notificaciones
  });
  const [message, setMessage] = useState('');
  const db = getFirestore();

  useEffect(() => {
    const fetchUserData = async () => {
      if (currentUser) {
        const docRef = doc(db, 'users', currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          console.error('No such document!');
        }
      }
    };

    fetchUserData();
  }, [currentUser, db]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData({
      ...userData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, 'users', currentUser.uid);
      await updateDoc(docRef, userData);
      setMessage('Perfil actualizado con éxito');
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      setMessage('Error al actualizar el perfil');
    }
  };

  return (
    <>
      <Navbar />
      <div className="edit-profile-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nombre</label>
            <input
              type="text"
              id="name"
              name="name"
              value={userData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="apellido">Apellido</label>
            <input
              type="text"
              id="apellido"
              name="apellido"
              value={userData.apellido}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefono">Teléfono</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              value={userData.telefono}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              value={userData.email}
              onChange={handleChange}
              readOnly
            />
          </div>
          <div className="form-group">
            <label htmlFor="recibirNotificaciones">
              ¿Desea recibir notificaciones de ofertas?
            </label>
            <input
              type="checkbox"
              id="recibirNotificaciones"
              name="recibirNotificaciones"
              checked={userData.recibirNotificaciones}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="save-button">Guardar Cambios</button>
        </form>
        {message && <p className="message">{message}</p>}
      </div>
    </>
  );
};

export default EditProfile;
